<template>
  <div>
    <div class="rew19_select_intitle">
      <em>매월</em>
      <span class="rew19_form_full">
        <select class="rew19_select_t1 autoFocus"
          v-if="paymentCase == '1'"
          v-model="deliveryDay"
          @change="checkDeliveryDay"
          >
          <option value="">원하시는 날짜를 선택해 주세요</option>
          <option value="11">11 (결제일 4일)</option>
          <option value="12">12 (결제일 5일)</option>
          <option value="13">13 (결제일 6일)</option>
          <option value="14">14 (결제일 7일)</option>
          <option value="15">15 (결제일 8일)</option>
          <option value="16">16 (결제일 9일)</option>
          <option value="17">17 (결제일 10일)</option>
          <option value="18">18 (결제일 11일)</option>
          <option value="19">19 (결제일 12일)</option>
          <option value="20">20 (결제일 13일)</option>
          <option value="21">21 (결제일 14일)</option>
          <option value="22">22 (결제일 15일)</option>
          <option value="23">23 (결제일 16일)</option>
          <option value="24">24 (결제일 17일)</option>
          <option value="25">25 (결제일 18일)</option>
          <option value="26">26 (결제일 19일)</option>
        </select>
        <select class="rew19_select_t1 autoFocus"
          v-if="paymentCase == '2' || paymentCase == '3'"
          v-model="deliveryDay"
          @change="checkDeliveryDay"
          >
          <option value="">원하시는 날짜를 선택해 주세요</option>
          <option value="11">4</option>
          <option value="12">5</option>
          <option value="13">6</option>
          <option value="14">7</option>
          <option value="15">8</option>
          <option value="16">9</option>
          <option value="17">10</option>
          <option value="18">11</option>
          <option value="19">12</option>
          <option value="20">13</option>
          <option value="21">14</option>
          <option value="22">15</option>
          <option value="23">16</option>
          <option value="24">17</option>
          <option value="25">18</option>
          <option value="26">19</option>
          <option value="28" v-if="paymentCase == '3'">21</option>
          <option value="29" v-if="paymentCase == '3'">22</option>
          <option value="30" v-if="paymentCase == '3'">23</option>
        </select>
        <select class="rew19_select_t1 autoFocus"
          v-if="paymentCase == '4'" v-model="deliveryDay" @change="checkDeliveryDay">
          <option value="">원하시는 날짜를 선택해 주세요</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
          <option value="14">14</option>
          <option value="15">15</option>
          <option value="16">16</option>
          <option value="17">17</option>
          <option value="18">18</option>
          <option value="19">19</option>
          <option value="20">20</option>
          <option value="21">21</option>
        </select>
      </span>
      <em>일</em>
    </div>
    <ul class="rew19_payment_productDl">
      <li v-if="paymentCase == '1'"><span>수령 희망일 8일(1일 결제), 9일(2일 결제), 10일(3일 결제), 27일(20일 결제)은</span> 배송이 집중되어 희망일 선택이 불가합니다. 원활한 서비스 제공을 위해 다른 날짜를 선택하여 주시기 바랍니다.</li>
      <li v-if="paymentCase != '1'">자동결제 다음날부터 3일 이내 배송됩니다.(영업일 기준)</li>
      <li v-if="paymentCase != '1'">자동 결제일 3일, 22일, 23일은 주문량이 집중되어 선택이 불가합니다. 원활한 서비스 제공을 위해 다른 날짜를 선택하여 주시기 바랍니다.</li>
      <li v-if="paymentCase != '1'">자동 결제일 선택 제한은 상황에 따라 변경될 수 있습니다.</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "WishDelivery",
  props: {
    mode: {
      type: String,
      default: ""
    },
    paymentCase: {
      type: String,
      default: "1"
    }
  },
  data() {
    return{
      deliveryDay: '',
    }
  },
  methods: {
    getData(){
      let _this = this;

      return _this.deliveryDay;
    },
    validation(){
      let _this = this;

      if(_this.deliveryDay == ''){
        if(_this.paymentCase == '1'){
          _this.$dialogs.alert("수령희망일을 선택해 주세요.", {title: "수령일 확인"}).then(res => {});
        }else{
          _this.$dialogs.alert("자동 결제일을 선택해 주세요.", {title: "자동 결제일 확인"}).then(res => {});
        }

        return false;
      }

      return true;
    },

    checkDeliveryDay(){
      let _this = this;

      // if(_this.deliveryDay == 8 || _this.deliveryDay == 9){
      //   _this.$dialogs.alert("수령 희망일 8일(1일 결제), 9일(2일 결제), 27일(20일 결제)은 배송이 집중되어 희망일 선택이 불가합니다. 원활한 서비스 제공을 위해 다른 날짜를 선택하여 주시기 바랍니다.", {title: "수령일 확인"})
      //   .then(res => {
      //     _this.deliveryDay = 10;
      //     _this.$emit('changed', _this.deliveryDay);
      //   });
      //   return;
      // }else{
        _this.$emit('changed', _this.deliveryDay);
      // }

    }
  }
};
</script>
<style>
.fontB {font-weight: bold; color: #000;}
</style>



// WEBPACK FOOTER //
// src/components/payment/WishDelivery.vue